import { useState } from "react";
import Button from "components/button";
import SideDrawer from "components/drawer";
import UserForm from "./user-form";

const FORM_ID = "new-person-form";

/**
 * Drawer with the create-person form. Submit lives in the drawer footer.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {() => Promise|void} [props.onSuccess] Refreshes the list after a create.
 */
const NewUser = ({ isOpen, onClose, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      title="Add Person"
      subtitle="Create a profile for someone in your church."
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" form={FORM_ID} loading={submitting}>
            {submitting ? "Saving…" : "Create Person"}
          </Button>
        </>
      }
    >
      <UserForm
        formId={FORM_ID}
        hideActions
        onSubmittingChange={setSubmitting}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </SideDrawer>
  );
};

export default NewUser;
